import Bowser from "bowser";

export enum WEBVIEW_APPS {
  FACEBOOK = "Facebook",
  INSTAGRAM = "Instagram",
  LINKEDIN = "LinkedIn",
  TWITTER = "Twitter",
}

type App = WEBVIEW_APPS | null;

type isWebViewResult = {
  app: App;
};

const getApp = (browser: Bowser.Parser.Parser): App => {
  if (browser.test(/FB[AN|IOS|DV|MD|SN|SV|SS|ID|LC|CR]/)) {
    return WEBVIEW_APPS.FACEBOOK;
  }
  if (browser.test(/\[LinkedInApp\]/)) {
    return WEBVIEW_APPS.LINKEDIN;
  }

  return null;
};

/** @deprecated https://github.com/remo-co/remo-conference/issues/6956 */
export const webViewInfo = (browser: Bowser.Parser.Parser): isWebViewResult => {
  const app = getApp(browser);

  return {
    app,
  };
};
